import { cx } from '#/Scripts/utilities/cx';
import Button from '#sign-up/components/common/Button/Button';
import { ButtonVariants } from '#sign-up/components/common/Button/buttonTypes';
import { SignupStep } from '#sign-up/components/SignUp/types';

export const SignUpNavigation = ({
  currentStep,
  onBack,
  onSubmit,
  isSubmitting,
}: {
  currentStep: SignupStep;
  onBack: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
}) => {
  let buttonText: string;

  if (currentStep === SignupStep.Finish) {
    buttonText = 'Finish Application';
  } else {
    buttonText = 'Next';
  }

  return (
    <div className="signup-navigation">
      <div className="navigation-button-container">
        {currentStep !== SignupStep.MainContact && (
          <Button
            variant={ButtonVariants.outline}
            className={cx(isSubmitting && 'disabled')}
            onClick={onBack}
            disabled={isSubmitting}
          >
            Previous
          </Button>
        )}
        <Button type="button" className={cx(isSubmitting && 'disabled')} onClick={onSubmit} disabled={isSubmitting}>
          {buttonText}
        </Button>
      </div>
    </div>
  );
};
